import { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const LineReveal = ({ lines, as: Tag = "h1", className = "", lineClassName = "", delay = 0 }) => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px 0px" });
  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? false : { y: "110%" }}
            animate={inView ? { y: 0 } : undefined}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`text-xs font-bold uppercase tracking-[0.22em] text-rose ${className}`}>
    {children}
  </p>
);
